<template>


  <div>

      <Loader
      :isLoading='this.Loading'
      />
      <Header
      :BackPage='false'
      :HideCart='true'
      :Title='colecao.nome'
      class="" 
      />



      <MainContainer>


        <HeaderColecao
        :ColecaoImg='this.prod.img'
        :ColecaoNome='this.prod.nome'
        :ColecaoDescricao='this.prod.descricao'
        class=''
        />

        <ProductList
        :arrayProduct='this.prod.products'
        :linhaProdutos='this.title'
        :Loading='this.loader'
        :NotProduct='NotProduct'
        :UserId='this.userLocalId'
        />



      <div class='container fixed-bottom mt-5' v-show=' this.pre_cart_itens != 0'>
        <ButtonGoToCart
        class=' pulse'
        :Valor=' this.pre_cart_itens'
        :Itens='this.pre_cart_total '
        :ButtonFunction='this.goToCart'
        />
      </div>

        </MainContainer>

  </div>
</template>

<script>
import ProductList from './ProductListColecao'
import Header from '../../components/Header/Header'
import MainContainer from '../../components/Container/MainContainer'
import Loader from '../../components/Load/LoadOverlay'
import HeaderColecao from './HeaderColecao'
import {mapActions, mapState} from 'vuex'
import ButtonGoToCart from '../../components/Button/ButtonGoToCart'

  export default {

    components: {
      ProductList,
      Header,
      MainContainer,
      Loader,
      HeaderColecao,
      ButtonGoToCart
    },
    data() {
      return {
        Pesquisar:true,
         loader: false,
         NotProduct: false,
         arrayCategorie: [],
         arrayProduct: [],
         carro : '',
         categoria: '',
         selected:'inital',
         title:' ',
         Loading:false,
         colecao:{},

      }
    },
    computed: {
        ...mapState('pre_cart',['pre_cart_itens','pre_cart_total']),
      ...mapState('product_list',['get_product']),
        userLocalId (){
          return localStorage.getItem('id_user');
        },
        prod () {
          return this.get_product
        }

    },
    methods: {
      ...mapActions('product_list',['ActionGetProduct','ActionDeleteGetProduct']),
     async  inital (){
                  this.Loading = true
          const localColecao = localStorage.getItem('colecao')
          if (localColecao) {

          this.ActionDeleteGetProduct()
     
         await  this.ActionGetProduct({id_produto:localColecao})
         this.Loading = false
     
        
      }
      },
          goToCart(){
      this.$router.push({name:'cart_checkout'})
    }
 

    },
    created () {
      this.inital()

    },
    mounted () {
      


    
    },

  }
</script>

<style lang="css" scoped>

.btn-primary {
    color: var(--main-red-black);
    background-color: var(--main-white);
    border-color: var(--main-red-black);
}

.btn-outline-primary {
    color: var(--main-red-black);
    border-color: var(--main-red-black);
}

.title-list{
    font-size: 1rem;
  font-weight:900;
  padding-top:1%;
  font-family: 'Roboto',sans-serif;
  color:var(--main-red-black);
  text-transform:uppercase;
}

.btn-primary:focus,.btn-primary:active {
   outline: none !important;
   box-shadow: none;
}


.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .open>.dropdown-toggle.btn-primary {
    color: #fff;
    background-color: var(--main-red-black);
    /*set the color you want here*/
}

.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: var(--main-red-black);
    border-color: var(--main-red-black);
}

.list-group-item-warning {
    color: var(--main-red-black);
    background-color: var(--main-white);
    border: 0.019rem solid var(--main-red-light);
}
.list-group-item.active {
    z-index: 2;
    color: var(--main-white);
    background-color: var(--main-red-black);
    border-color: var(--main-red-black);
    border-style: solid;
}

.pulse {
  background: var(--main-red-black);
  cursor: pointer;
  box-shadow: var(--main-black);
  animation: pulse 1s infinite;
}
.pulse:hover {
  animation: none;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(15, 15, 15, 0.4);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba(92, 6, 6, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(56, 4, 11, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(10, 10, 10, 0.4);
    box-shadow: 0 0 0 0 rgba(15, 15, 15, 0.4);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(199, 7, 7, 0);
      box-shadow: 0 0 0 10px rgba(207, 7, 7, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(207, 11, 21, 0);
      box-shadow: 0 0 0 0 rgba(204, 44, 44, 0);
  }
}
</style>
